import { InputNumber } from "antd";
import styled from "styled-components";

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    .ant-form-item {
        margin-bottom: 0;
    }
`;

export const StyledWeekDays = styled.div`
    width: 100%;

    .ant-checkbox-group {
        width: 100%;
        justify-content: space-between;
    }

    .ant-checkbox {
        display: none;
    }

    .ant-checkbox-wrapper > span:last-child {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme.disabledTypographyColor};
        color: ${({ theme }) => theme.colors.white};
        transition: all 0.2s;
        padding: 0;
    }

    .ant-checkbox-wrapper-checked > span:last-child {
        background-color: color-mix(
            in srgb,
            ${({ theme }) => theme.colors.primary} 90%,
            white 10%
        );
    }
`;

export const StyledInputWeekly = styled(InputNumber)`
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;

    input {
        text-align: center !important;
    }
`;

export const StyledCalendarWrapper = styled.div`
    .ant-picker {
        width: 100%;
        padding: 10px;
    }

    .ant-picker-suffix {
        font-size: 20px;
    }
`;

export const StyledCell = styled.div<{
    $isInWeek?: boolean;
    $isStart?: boolean;
    $isEnd?: boolean;
}>`
    padding: 5px 10px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ $isInWeek, theme }) =>
        $isInWeek ? theme.selectedCalendarDaysColor : "transparent"};
    border-top-left-radius: ${({ $isStart, $isInWeek }) =>
        $isStart && $isInWeek ? "4px" : "0px"};
    border-bottom-left-radius: ${({ $isStart, $isInWeek }) =>
        $isStart && $isInWeek ? "4px" : "0px"};
    border-top-right-radius: ${({ $isEnd, $isInWeek }) =>
        $isEnd && $isInWeek ? "4px" : "0px"};
    border-bottom-right-radius: ${({ $isEnd, $isInWeek }) =>
        $isEnd && $isInWeek ? "4px" : "0px"};
`;
